<!--
 * @Author: Wang Xiaomei XianYuPigeon@outlook.com
 * @Date: 2025-02-28 20:10:16
 * @LastEditors: Wang Xiaomei XianYuPigeon@outlook.com
 * @LastEditTime: 2025-03-06 07:00:00
 * @FilePath: /personal-page/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container">
    <!-- 左侧：图片滚动区域 -->
    <div class="left-panel">
      <ImageGallery />
    </div>
    
    <!-- 右侧：个人简介和可展开菜单 -->
    <div class="right-panel">
      <ProfileInfo />
    </div>
    
    <!-- 添加调试面板 -->
    <DebugPanel v-if="isDev" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import ImageGallery from './components/ImageGallery.vue';
import ProfileInfo from './components/ProfileInfo.vue';
import DebugPanel from './components/debug.vue';

export default defineComponent({
  name: 'App',
  components: {
    ImageGallery,
    ProfileInfo,
    DebugPanel
  },
  setup() {
    // 检测是否为开发环境
    const isDev = ref(process.env.NODE_ENV === 'development');
    
    // 设置页面标题
    onMounted(() => {
      document.title = '椰羊';
    });
    
    return { isDev };
  }
});
</script>

<style>
:root {
  --left-scroll-speed: 60s;
  --middle-scroll-speed: 70s;
  --right-scroll-speed: 80s;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  background-color: #121212;
  color: #e0e0e0;
  font-family: 'Roboto', sans-serif; /* 应用 Google Pixel Font */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  display: flex;
  min-height: 100vh;
  gap: 5px; /* 统一面板间隙为5px */
  padding: 5px; /* 统一整体容器内边距为5px */
}

.left-panel {
  flex: 1.6; /* 略微增加左侧面板的比例 */
  overflow-y: auto;
  background-color: #121212;
  border-right: none; /* 移除边框，改用间隙 */
  border-radius: 10px; /* 添加圆角 */
  margin: 0; /* 移除所有外边距 */
}

.right-panel {
  flex: 1; /* 减小右侧面板的比例 */
  background-color: #1a1a1a;
  padding: 25px 20px 15px; /* 调整底部内边距，为页脚留出空间 */
  overflow-y: auto;
  border-left: none; /* 移除边框，改用间隙 */
  border-radius: 10px; /* 添加圆角 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  margin: 0; /* 移除所有外边距 */
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2); /* 减小阴影 */
}

/* 添加圆角的全局样式 */
button, input, textarea, select {
  border-radius: 8px;
}

a {
  color: #66d9ff;
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: #1ad1ff;
}

/* 增加滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #1a1a1a;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #444;
}

/* 字体粗细变化 */
h1, h2, h3, h4, h5, h6 {
  font-weight: 500; /* Pixel 风格通常使用中等字重 */
}

/* 增强可读性 */
p, li {
  font-weight: 300; /* 正文使用较轻字重 */
  line-height: 1.7;
}

strong, b {
  font-weight: 500; /* 强调使用中等字重 */
}

/* 响应式布局 */
@media (max-width: 1024px) {
  .container {
    flex-direction: column;
    gap: 5px; /* 保持统一间隙 */
    padding: 5px; /* 保持统一内边距 */
  }
  
  .left-panel, .right-panel {
    flex: none;
    width: 100%;
    height: 50vh;
    margin: 0; /* 保持无外边距 */
  }
}

/* 手机视图 - 隐藏左侧画廊 */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 0;
  }
  
  .left-panel {
    display: none; /* 隐藏左侧画廊 */
  }
  
  .right-panel {
    flex: 1;
    width: 100%;
    height: 100vh; /* 占据全部高度 */
    border-radius: 0; /* 移除圆角 */
    padding: 20px 15px; /* 适当调整内边距 */
  }
}

/* 添加全局字体定义，用于代码块 */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500&display=swap');

/* 全局代码样式，确保覆盖任何可能的冲突 */
pre, code {
  font-family: 'Fira Code', 'Consolas', 'Monaco', monospace !important;
}
</style>
